import liff from '@line/liff'

import type { CreateClientConfig } from './client/client.gen'

export const createClientConfig: CreateClientConfig = (config) => ({
  ...config,
  baseUrl: import.meta.env.VITE_API_URL,
  kyOptions: {
    hooks: {
      beforeRequest: [
        (request) => {
          try {
            const token = liff.getAccessToken()
            if (token) {
              request.headers.set('Authorization', `Bearer ${token}`)
            }
          } catch (e) {
            // liff might not be initialized yet, ignore
          }
        },
      ],
    },
  },
})
